<div class="myH_listbase my-4 pr-3">
  <div class="myH_list_wrap d-none d-md-flex">
    <div
      class="myH_pill"
      [ngClass]="{ active: selectedPmxId == home.PMXPropertyId }"
      *ngFor="let home of myHomeList"
      (click)="selectedHome(home)"
      matTooltip="{{ home.streetAddress }}"
    >
      <div class="myH_image"><img src="../../../assets/images/Home.svg" /></div>
      <div>
        <h6>{{ home.streetAddress }}.</h6>
        <p class="mb-0">{{ home.city }},{{ home.state }}</p>
      </div>
      <button class="close" (click)="deleteProperty(home.id)">x</button>
    </div>
  </div>

  <mat-form-field class="d-block d-md-none">
    <mat-label>Select Property</mat-label>
    <mat-select matNativeControl [(ngModel)]="selectedHomeValue" required>
      <mat-option
        (click)="selectedHome(home)"
        [ngClass]="{ active: selectedPmxId == home.PMXPropertyId }"
        *ngFor="let home of myHomeList"
        [value]="home"
        matTooltip="{{ home.streetAddress }}"
      >
        {{ home.streetAddress }} {{ home.city }},{{ home.state }}
        <!-- <div>
        <p class="mb-0">{{home.city}},{{home.state}}</p>
      </div> -->
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button class="addProp p-0" mat-flat-button color="primary" (click)="addProperty()" matTooltip="Add New Property">
    <img src="../../../assets/images/addproperty.svg" width="26px" />
  </button>
  <!-- <button class="float-right" mat-flat-button mat-stroked-button (click)="tradeUpProperty()">
    Trade Up / Buy Property
  </button> -->
  <button
    class="float-right ml-3"
    mat-flat-button
    mat-stroked-button
    *ngIf="contactAgentEnabled"
    (click)="contactAgent()"
  >
    Contact Agent
  </button>
  <button
    class="float-right ml-3"
    mat-flat-button
    mat-stroked-button
    *ngIf="contactLenderEnabled"
    (click)="contactLender()"
  >
    Contact Lender
  </button>
  <button class="float-right" mat-flat-button mat-stroked-button *ngIf="listMyHomeEnabled" (click)="listMyHome()">
    List My Home
  </button>
</div>
<!-- <button class="float-rightt" mat-flat-button color="primary" (click)="addProperty()">Add Property</button> -->
